export const agentsTableConfig = {
    "tableDefinition": {
        "tooltip": "",
        "columns": [
            {
                "name": "code",
                "label": "Broker Number",
                "displayField": "code"
            },
            {
                "name": "vendor",
                "label": "Vendor",
                "displayField": "vendor"
            },
            {
                "name": "name",
                "label": "Broker Name",
                "displayField": "name"
            },
            {
                "name": "address",
                "label": "Address",
                "displayField": "address"
            },
            {
                "name": "ibm_address",
                "label": "IBM Address",
                "displayField": "ibm_address"
            }
        ]
    }
}